import script from "./LinkCurvedIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkCurvedIcon.vue?vue&type=script&setup=true&lang=js"

export default script